import { render, staticRenderFns } from "./carousel-transition-effect.vue?vue&type=template&id=c01e3d96&"
import script from "./carousel-transition-effect.vue?vue&type=script&lang=js&"
export * from "./carousel-transition-effect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports